@if(envelope) {
  <h1 mat-dialog-title>{{ 'manageEnvelope.manageHubReportEnvelope' | transloco }}</h1>
  <mat-dialog-content>
    <div class="table-container">
      <table mat-table [dataSource]="[envelope]" multiTemplateDataRows>
        <ng-container matColumnDef="logs">
          <th mat-header-cell *matHeaderCellDef id="logs"> </th>
          <td mat-cell *matCellDef="let envelope">
            <div class="flex-container-center">
              <button mat-flat-button color="primary" (click)="viewLogs(envelope)">
                {{ 'common.labels.logs' | transloco }}
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="added">
          <th mat-header-cell *matHeaderCellDef id="added">
            <div class="flex-container-center">
              {{ 'manageEnvelope.creationDate' | transloco }}
            </div>
          </th>
          <td mat-cell *matCellDef="let envelope">
            <div class="flex-container-center">
              {{ envelope.added | localizedDate }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="numOrders">
          <th mat-header-cell *matHeaderCellDef id="numOrders">
            <div class="flex-container-center">
              {{ 'common.labels.orders' | transloco }}
            </div>
          </th>
          <td mat-cell *matCellDef="let envelope">
            <div class="flex-container-center">
              <button mat-flat-button color="primary">
                {{ envelope.envelopeOrders.length }}
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="previous">
          <th mat-header-cell *matHeaderCellDef id="previous"> </th>
          <td mat-cell *matCellDef="let envelope">
            <div class="flex-container-center">
              <button mat-flat-button color="primary"
                [disabled]="!envelope.envelopeStatus.isPreviousAvailable || isProcessing"
                (click)="previous(envelope)">
                {{ envelope.envelopeStatus.previousActionName ?? 'Prev' }}
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef id="icon"> </th>
          <td mat-cell *matCellDef="let envelope">
            <div class="flex-container-center">
              @if (!isProcessing) {
                <mat-icon>{{ getIcon(envelope) }}</mat-icon>
              } @else {
                <div class="spinner-inline-container">
                  <div class="spinner-inline"> </div>
                </div>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef id="status">
            <div class="flex-container-center">
              {{ 'common.labels.status' | transloco }}
            </div>
          </th>
          <td mat-cell *matCellDef="let envelope">
            <div class="flex-container-center">
              @if (!isProcessing) {
                <span>{{ envelope.envelopeStatus.id }}</span>
              } @else {
                <span>{{ 'manageEnvelope.processing' | transloco }}</span>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="next">
          <th mat-header-cell *matHeaderCellDef id="next"> </th>
          <td mat-cell *matCellDef="let envelope">
            <div class="flex-container-center">
              <button mat-flat-button color="primary"
                [disabled]="!envelope.envelopeStatus.isNextAvailable || isProcessing"
                (click)="next(envelope)">
                {{ envelope.envelopeStatus.nextActionName ?? 'Next' }}
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="updateState">
          <th mat-header-cell *matHeaderCellDef id="updateState">
            <div class="flex-container-center">
              {{ 'manageEnvelope.manageState' | transloco }}
            </div>
          </th>
          <td mat-cell *matCellDef="let envelope">

            <div class="custom-select-container">
              <select class="custom-select form-control" id="statusUpdateSelect" [attr.aria-label]="'manageEnvelope.updateEnvelopeStatus' | transloco"
                [(ngModel)]="updateStatus">
                <option> </option>
                <option value="Open">{{ 'manageEnvelope.open' | transloco }}</option>
                <option value="DocumentProcessing">DocumentProcessing</option>
              </select>
              <button mat-icon-button color="primary" [attr.aria-label]="'manageEnvelope.saveStatus' | transloco"
                (click)="saveStatus(envelope)"><mat-icon>save</mat-icon></button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button mat-dialog-close [mat-dialog-close]="false">{{ 'common.buttons.close' | transloco }}</button>
    </mat-dialog-actions>
  }